var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2539 16.25H7.20312C4.51418 16.25 3.16972 16.25 2.33437 15.3987C1.49902 14.5476 1.49902 13.1775 1.49902 10.4375C1.49902 7.69746 1.49902 6.32744 2.33437 5.47622C3.16972 4.625 4.51418 4.625 7.20312 4.625H10.0552C12.7441 4.625 14.0886 4.625 14.9239 5.47622C15.5666 6.13114 15.7148 7.09317 15.749 8.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1365 14.6375L13.124 13.9625V12.275M9.74902 13.625C9.74902 15.489 11.26 17 13.124 17C14.988 17 16.499 15.489 16.499 13.625C16.499 11.761 14.988 10.25 13.124 10.25C11.26 10.25 9.74902 11.761 9.74902 13.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 4.625L11.9265 4.3932C11.5552 3.23817 11.3696 2.66065 10.9277 2.33032C10.4857 2 9.89873 2 8.72468 2H8.52728C7.35326 2 6.76625 2 6.32431 2.33032C5.88237 2.66065 5.69675 3.23817 5.32548 4.3932L5.25098 4.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExp);
export default __webpack_public_path__ + "static/media/workExp.6936919b14f4ab2b47cefd028b75fad2.svg";
export { ForwardRef as ReactComponent };